import axios from "axios";
import { createHeaders } from "./Constant";

const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-test.finhub.habilelabs.io": "/vkyc-backend/api",
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend",
};

const backendBase = isLocal
  ? "http://localhost:8000"
  : baseMap[hostname] || "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend";

console.log('SessionsService - Hostname:', hostname);
console.log('SessionsService - Is Local:', isLocal);
console.log('SessionsService - Base URL:', backendBase);

export const panService = {
  async extractPan(panFileBlob, sessionId, requestId, customerSession) {
    const form = new FormData();
    form.append("session_id", sessionId);
    form.append("request_id", requestId);
    form.append("pan_image", panFileBlob, "pan.jpg");
    if (customerSession) form.append("session", customerSession);

    const response = await axios.post(
      `${backendBase}/api/v1/pan-ocr/`,
      form,
      {
        headers: {
          ...createHeaders(),
          'Content-Type': 'multipart/form-data',
          'session': customerSession
        },
      }
    );
        console.log('response :', response);

    return response.data;
  },
}; 